import React, { useEffect, useContext } from 'react'
import { Pet } from '../../types'
import { PetFilters } from '../PetFilters'
import { PetList } from '../PetList'
import { PetsContext } from '../PetsProvider'

export const App = ({
  getPetsOrdered
}: {
  getPetsOrdered: () => Promise<Pet[]>
}) => {
  const { setPetsValue } = useContext(PetsContext)

  useEffect(() => {
    async function effect () {
      const petsFromAPI = await getPetsOrdered()
      setPetsValue(petsFromAPI)
    }

    effect()
  }, [getPetsOrdered, setPetsValue])

  return (
    <div className='pet-app'>
      <PetFilters />
      <PetList />
    </div>
  )
}
